import {Link} from 'react-router-dom';
import {dateCompare} from '../../../util/helpers';
import {Communication} from '../../../util/types';
import Icon from '../Icon';
import Routing from "../../../Routing.ts";
import IconAlert from "../../icons/IconAlert.tsx";
import IconNotification from "../../icons/IconNotification.tsx";

export function StatusIndicatorWithNotifications({unread, alert}: {unread: Communication[], alert: boolean}) {
    const unreadCount = unread.length;
    const unreadSorted = unread.sort((a, b) => dateCompare(a.sent_dtm, b.sent_dtm)).reverse();
    const oldestUnread = unreadSorted[unreadSorted.length - 1];
    const link = '#notifikation-' + oldestUnread.request_id;

    // kbd: IDK WTF `state` is in Link
    return <div className={`selfcare-delivery-flow-status${alert ? ' selfcare-delivery-flow-status--alert' : ''}`}>
        {alert ?
            <Icon component={IconAlert}/>
        :
            <Icon component={IconNotification}/>
        }
        <p>Du har {unreadCount > 1 ? unreadCount + ' ulæste beskeder' : 'en ulæst besked'}</p>
        <Link to={link} state={{from_url: Routing.Selfcare.Index}}>
            <span className="text">
                Vis {unreadCount > 1 ? 'beskeder' : 'besked'}
            </span>
        </Link>
    </div>;
}
